module.exports = __webpack_public_path__ + "static/media/exhibition-hall.a1f4f23e.png";